import React from "react";
import { Avatar, Button, Card, Grid, Text, Icon, Link, Box, Modal } from "~/components-shared";
import styled from "styled-components";
import StyledIcon from "~/components/StyledIcon";
const InfoButton = styled(Button)`
  position: absolute;
  top: 1rem;
  right: 1rem;
`;
const StyledText = styled(Text)`
  overflow: hidden;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const Cap = styled.div`
  display: inline-block;
  width: ${_ref => {
  let {
    theme
  } = _ref;
  return 6 * theme.typography.fontStep;
}}rem;
  min-width: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return 6 * theme.typography.fontStep;
}}rem;
  height: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return 6 * theme.typography.fontStep;
}}rem;
  text-align: center;
  line-height: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return 6 * theme.typography.fontStep;
}}rem;
  border-radius: 50%;
  background-color: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colors.primary.light;
}};
  position: relative;
  font-weight: ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.typography.fontWeight.semiBold;
}};
  font-size: ${_ref7 => {
  let {
    theme
  } = _ref7;
  return 3 * theme.typography.fontStep;
}}rem;
  color: ${_ref8 => {
  let {
    theme
  } = _ref8;
  return theme.colors.primary.main;
}};
  box-shadow: 0 0 0 2px ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme.colors.background.primary;
}};
`;
const StyledAvatar = styled(Avatar)`
  box-shadow: 0 0 0 2px ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme.colors.background.primary;
}};
`;
const BelongingCard = _ref11 => {
  let {
    widget,
    ...rest
  } = _ref11;
  const {
    items
  } = widget.data;
  const [open, setOpen] = React.useState(false);
  const cardItem = function (item) {
    let detailed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let {
      members
    } = item;
    if (!detailed) {
      members = item.members.slice(0, 5);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledText, {
      fontSize: 4
    }, item.name), /*#__PURE__*/React.createElement(Box, {
      align: "center",
      justify: "end"
    }, members.map(member => /*#__PURE__*/React.createElement(StyledAvatar, {
      s: {
        mr: -1
      },
      style: {
        verticalAlign: "text-bottom"
      },
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-content": `${member.firstName} ${member.lastName}${member.email ? ` (${member.email})` : ""}`,
      size: 6,
      user: member
    })), !detailed && item.members.length > 5 && /*#__PURE__*/React.createElement(Cap, null, "+", item.members.length - 5)));
  };
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    fontSize: 8,
    s: {
      mb: 6
    }
  }, "Team Belonging"), items.length ? /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "auto auto",
    align: "center",
    gap: 3
  }, items.slice(0, 6).map(item => cardItem(item))) : /*#__PURE__*/React.createElement(Grid, {
    cols: 1,
    justify: "center",
    s: {
      mt: 8
    }
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    src: "people",
    color: "translucentPrimary"
  }), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    weight: "semiBold",
    display: "block",
    s: {
      mt: 6
    },
    align: "center",
    style: {
      maxWidth: "400px"
    }
  }, "No identified teams")), items.length > 6 && /*#__PURE__*/React.createElement(Box, {
    justify: "end",
    s: {
      mt: 5
    }
  }, /*#__PURE__*/React.createElement(Link, {
    color: "primary",
    onClick: () => setOpen(true),
    fontSize: 4
  }, "See all", /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    s: {
      ml: 1,
      mt: -0.5
    }
  }))), /*#__PURE__*/React.createElement(InfoButton, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": "Info",
    color: "translucentPrimary",
    display: "inline",
    fontSize: 3,
    lineHeight: 3,
    s: {
      p: 1,
      ml: 2
    },
    outline: false,
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 4,
    src: "infoOutline"
  })), /*#__PURE__*/React.createElement(Modal, {
    open: open
  }, /*#__PURE__*/React.createElement(Modal.Body, {
    title: "Team Belonging",
    onClose: () => setOpen(false),
    maxWidth: "600px",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "auto auto",
    align: "center",
    gap: 3
  }, items.map(item => cardItem(item, true)))))));
};
export default BelongingCard;